import AddressLines from 'components/ui-components/AddressLines';
import propTypes from 'prop-types';
import Button from 'components/ui-components/Button';

const DetailContainer = ({
  contClass,
  title,
  titleClass,
  details,
  onClick,
  detailClass,
  btnText,
}) => (
  <div className={contClass || ''}>
    <h2 className={`fs-22 mb-0 ${titleClass || ''}`}>{title}</h2>
    {details.map(({ name, value, optional }) => {
      if (value === '' && !optional) {
        return (
          <div
            className={`summary-detail pb-13 pt-13 ${detailClass || ''}`}
            key={name}>
            <p className="summary-detail__key fs-16 mb-3 fw-600">{name}</p>
            <div className="fl jc-sb ai-fs">
              <p className="summary-detail__value fs-16 mb-0 tc-cef-red">
                Please select a {name}.
              </p>

              <Button
                className="cef-btn--as-ul-link"
                type="button"
                handleClick={() => onClick()}>
                {btnText}
              </Button>
            </div>
          </div>
        );
      }
      return (
        value && (
          <div
            className={`summary-detail pb-13 pt-13 ${detailClass || ''}`}
            key={name}>
            <p className="summary-detail__key fs-16 mb-3 fw-600">{name}</p>
            <div className="fl jc-sb ai-fs">
              {typeof value !== 'object' ? (
                <p className="summary-detail__value fs-16 mb-0">{value}</p>
              ) : (
                <AddressLines address={value} />
              )}
              <Button
                className="cef-btn--as-ul-link"
                type="button"
                handleClick={() => onClick()}>
                {btnText}
              </Button>
            </div>
          </div>
        )
      );
    })}
  </div>
);

DetailContainer.propTypes = {
  contClass: propTypes.string,
  title: propTypes.string,
  titleClass: propTypes.string,
  details: propTypes.array,
  onClick: propTypes.func,
  detailClass: propTypes.string,
  btnText: propTypes.string,
};

export default DetailContainer;
